(function () {
  function parseWishlistValue(value) {
    if (!value) return 0;

    try {
      var parsed = JSON.parse(value);

      if (Array.isArray(parsed)) {
        return parsed.filter(Boolean).length;
      }

      if (parsed && typeof parsed === 'object') {
        if (Array.isArray(parsed.items)) return parsed.items.filter(Boolean).length;
        if (Array.isArray(parsed.products)) return parsed.products.filter(Boolean).length;
        if (Array.isArray(parsed.wishlist)) return parsed.wishlist.filter(Boolean).length;

        return Object.keys(parsed).filter(function (key) {
          return parsed[key];
        }).length;
      }
    } catch (e) {
      return String(value)
        .split(',')
        .map(function (item) { return item.trim(); })
        .filter(Boolean).length;
    }

    return 0;
  }

  function getWishlistCountFromStorage() {
    var bestCount = 0;

    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key) continue;

        var cleanKey = key.toLowerCase();

        if (
          cleanKey.indexOf('wishlist') === -1 &&
          cleanKey.indexOf('wish-list') === -1 &&
          cleanKey.indexOf('bls_wishlist') === -1
        ) {
          continue;
        }

        var count = parseWishlistValue(localStorage.getItem(key));

        if (count > bestCount) {
          bestCount = count;
        }
      }
    } catch (e) {}

    return bestCount;
  }

  function getWishlistCountFromButtons() {
    var ids = {};
    var buttons = document.querySelectorAll(
      'button-wishlist[data-product-id][data-action="remove"], button-wishlist[data-product-id].active, .product-item__button-wishlist[data-product-id].active'
    );

    buttons.forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (id) ids[id] = true;
    });

    return Object.keys(ids).length;
  }

  function updateSmsmWishlistCount() {
    var count = getWishlistCountFromStorage();

    if (!count) {
      count = getWishlistCountFromButtons();
    }

    document.querySelectorAll('[data-smsm-wishlist-count], .smsm-wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('aria-label', count + ' wishlist items');
    });
  }

  document.addEventListener('DOMContentLoaded', updateSmsmWishlistCount);
  window.addEventListener('pageshow', updateSmsmWishlistCount);
  window.addEventListener('storage', updateSmsmWishlistCount);

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('button-wishlist') ||
      event.target.closest('.product-item__button-wishlist') ||
      event.target.closest('[data-product-id][data-action]')
    ) {
      setTimeout(updateSmsmWishlistCount, 150);
      setTimeout(updateSmsmWishlistCount, 600);
      setTimeout(updateSmsmWishlistCount, 1200);
    }
  }, true);

  document.addEventListener('wishlist:updated', updateSmsmWishlistCount);
  document.addEventListener('wishlist:change', updateSmsmWishlistCount);
  document.addEventListener('theme:wishlist:update', updateSmsmWishlistCount);
  document.addEventListener('shopify:section:load', updateSmsmWishlistCount);

  var observer = new MutationObserver(function () {
    clearTimeout(window.__smsmWishlistTimer);
    window.__smsmWishlistTimer = setTimeout(updateSmsmWishlistCount, 120);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-action', 'class']
  });
})();